import React, { useState, useEffect } from 'react'
import './index.css'
import Slider from 'react-slick'
import PropTypes from 'prop-types'
import { priorityTabs } from '../../../constants/constants'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import ProductBuildUpPriority from './productbuilduppriority'
import DodPriority from './dodpriority'

const Priority = ({ match }) => {

  const [tab, setTab] = useState(false)

  useEffect(() => {
    if (match?.params.tab) {
      if (priorityTabs[match.params.tab]) {
        setTab(priorityTabs[match.params.tab])
      } else {
        setTab(priorityTabs.priority)
      }
    } else {
      setTab(priorityTabs.priority)
    }
  }, [])


  const tabHnadler = (t) => {
    setTab(t)
    // history.push(`/gatekeeper/${t}`)
  }

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
    ]
  }

  return (
    <div>
      <Slider {...settings} className='custom-slider mb-24px'>
        <div className={`tabs ${tab == priorityTabs.priority? 'active-tab' : ''}`} onClick={() => tabHnadler(priorityTabs.priority)}>
          <span>Product Priority</span>
        </div>
        <div className={`tabs ${tab == priorityTabs.dod_priority? 'active-tab' : ''}`} onClick={() => tabHnadler(priorityTabs.dod_priority)}>
          <span>DOD Priority</span>
        </div>
      </Slider>


      {tab == priorityTabs.priority &&
        <ProductBuildUpPriority />
      }
      {tab == priorityTabs.dod_priority &&
        <DodPriority />
      }

    </div>
  )
}
Priority.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
}

export default Priority
